import { useContractOrdererStore } from '@/hooks/use-contract-orderer'
import classNames from 'classnames'
import { useI18n } from 'i18n-utils'
import { ContractTypeIces } from 'store/src/constants/common'
import { ArrowDownIcon, CustomButton, DialogHeader, HocElDialog } from 'ui-components'
import '../styles/pending-order-preference-layout.scss'

/**
 * 挂单偏好
 * @returns
 */
export const PendingOrderPreference = defineComponent({
  setup() {
    const { t } = useI18n()
    const orderer = useContractOrdererStore()

    const typesDetail = [
      '确保成交速度，第一单会挂在激进位置，买单挂在卖一位置，依次类推挂单。',
      '每次挂单都保持于盘口买一/卖一固定距离，并随着市价变化调整订单价格，确保以更优价格执行。',
      '每笔子订单都按照输入的价格进行依次挂出。',
    ]
    const selectIndex = ref(0)
    const tempSelectIndex = ref(0)
    const showSelectDialog = ref(false)
    const selectType = computed(() => {
      return ContractTypeIces[selectIndex.value]
    })

    const onConfirm = () => {
      selectIndex.value = tempSelectIndex.value
      showSelectDialog.value = false
      orderer.setPendingOrderPreference(selectIndex.value)
    }

    const onClose = () => {
      showSelectDialog.value = false
      tempSelectIndex.value = selectIndex.value
    }

    return () => (
      <div class="pending-order-preference-layout">
        <span class="placeholder">{t('挂单偏好')}</span>
        <div class="select-box" onClick={() => (showSelectDialog.value = true)}>
          {t(selectType.value)}
          <ArrowDownIcon />
        </div>

        <HocElDialog v-model={showSelectDialog.value} width={'520px'} showClose={false}>
          {{
            header: () => <DialogHeader onClose={onClose}>{t('选择挂单偏好')}</DialogHeader>,
            default: () => (
              <div class="select-dialog-content">
                <div class="preference-items">
                  {ContractTypeIces.map((item, index) => (
                    <div class={classNames('preference-item', { active: tempSelectIndex.value === index })} key={index} onClick={() => (tempSelectIndex.value = index)}>
                      {t(item)}
                    </div>
                  ))}
                </div>
                <div class="preference-detail">
                  {typesDetail.map((item, index) => (
                    <p class="preference-detail-item" key={index}>
                      <span class="preference-detail-item-title">*{t(ContractTypeIces[index])}:</span>
                      <span class="preference-detail-item-desc">{t(item)}</span>
                    </p>
                  ))}
                </div>
                <CustomButton class="confirm-btn" type={'primary'} onClick={onConfirm}>
                  {t('确认')}
                </CustomButton>
              </div>
            ),
          }}
        </HocElDialog>
      </div>
    )
  },
})
